import { render, staticRenderFns } from "./PriceCategoryToggleIsShowConfirmationModal.vue?vue&type=template&id=156452b9"
import script from "./PriceCategoryToggleIsShowConfirmationModal.vue?vue&type=script&lang=js"
export * from "./PriceCategoryToggleIsShowConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports